import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { getProfile } from "../../services/users.api";
import { useCompanyStoreActions, useCompanyStore } from "../../states/store/Company";
import { useCompanyAccessStore } from "../../states/store/CompanyAccess";
import { AuthContext, AuthType } from "./authContext/AuthContext";
import { useGetCompanyAccesses } from "@/common/hooks";
import { useAppStore } from "@/common/states/store";

export const AuthProvider = (props: PropsWithChildren) => {
  const {
    isAuthenticated,
    user,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
  } = useAuth0();
  // const [profile, setProfile] = useState<User>({});
  const [authReady, setAuthReady] = useState(false);
  const { setAllSelection, syncAvailableCompanies } = useCompanyStoreActions();
  const { removeCompanyAccess, addCompanyAccess } = useCompanyAccessStore();

  const getToken = useCallback(getAccessTokenSilently, [
    getAccessTokenSilently,
  ]);
  const email = authReady && user?.email ? user.email : undefined;
  const { data: companiesAccesses } = useGetCompanyAccesses(email);
  const { profile, setProfile } = useAppStore((state) => state.auth);

  useEffect(() => {
    if (!user) return;

    async function getUserProfile() {
      try {
        const data = await getProfile();
        if (data) {
          setProfile(data);
          setAuthReady(true);
        }
      } catch (err) {
        console.error("Erro ao buscar perfil:", err);
        setAuthReady(true);
      }
    }

    getUserProfile();
  }, [isAuthenticated, user, setProfile]);
  useEffect(() => {
    if (!authReady) return;

    const runCacheSync = async () => {
      const cacheKey = "all_active_companies_cache";

      if (!localStorage.getItem(cacheKey)) {
        await syncAvailableCompanies();
      }
    };

    runCacheSync();
  }, [authReady, syncAvailableCompanies]);
  useEffect(() => {
    if (!authReady || !companiesAccesses) return;

    if (!localStorage.getItem("companiesAccesses")) {
      addCompanyAccess(companiesAccesses);
    }
  }, [authReady, companiesAccesses, addCompanyAccess]);

  const auth = useMemo(() => {
    if (!isAuthenticated) return null;
    const mergedUser = {
      ...user,
      ...(profile?.userInfo || {}),
    };

    return {
      user: mergedUser,
      getToken,
    };
  }, [isAuthenticated, user, profile, getToken]);

  const handleLogout = () => {

    setAllSelection();
    removeCompanyAccess();

    sessionStorage.clear();

    localStorage.clear();

    useCompanyStore.setState({ availableCompanies: [] });

    setProfile(null);

    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <AuthContext.Provider
      value={{
        auth: auth as AuthType,
        login: loginWithRedirect,
        logout: handleLogout,
        authReady,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
